import styles from './Flex.module.css';

import { getSpacingStyles } from '../../styles/spacing/getSpacingStyles';
import type { FlexResponsiveProps } from './types';

/** Return the Flexbox CSS styles. */
export function getStyles(props: FlexResponsiveProps): string[] {
  const classNames: string[] = [];

  const justify =
    typeof props.justify === 'string' ? { xs: props.justify } : props.justify;

  if (justify?.xs) {
    classNames.push(styles[`justify-${justify.xs}`]);
  }
  if (justify?.sm) {
    classNames.push(styles[`justify-sm-${justify.sm}`]);
  }
  if (justify?.md) {
    classNames.push(styles[`justify-md-${justify.md}`]);
  }
  if (justify?.lg) {
    classNames.push(styles[`justify-lg-${justify.lg}`]);
  }
  if (justify?.xl) {
    classNames.push(styles[`justify-xl-${justify.xl}`]);
  }

  const direction =
    typeof props.direction === 'string'
      ? { xs: props.direction }
      : props.direction;

  if (direction?.xs) {
    classNames.push(styles[`direction-${direction.xs}`]);
  }
  if (direction?.sm) {
    classNames.push(styles[`direction-sm-${direction.sm}`]);
  }
  if (direction?.md) {
    classNames.push(styles[`direction-md-${direction.md}`]);
  }
  if (direction?.lg) {
    classNames.push(styles[`direction-lg-${direction.lg}`]);
  }
  if (direction?.xl) {
    classNames.push(styles[`direction-xl-${direction.xl}`]);
  }

  const alignItems =
    typeof props.alignItems === 'string'
      ? { xs: props.alignItems }
      : props.alignItems;

  if (alignItems?.xs) {
    classNames.push(styles[`align-items-${alignItems.xs}`]);
  }
  if (alignItems?.sm) {
    classNames.push(styles[`align-items-sm-${alignItems.sm}`]);
  }
  if (alignItems?.md) {
    classNames.push(styles[`align-items-md-${alignItems.md}`]);
  }
  if (alignItems?.lg) {
    classNames.push(styles[`align-items-lg-${alignItems.lg}`]);
  }
  if (alignItems?.xl) {
    classNames.push(styles[`align-items-xl-${alignItems.xl}`]);
  }

  const alignContent =
    typeof props.alignContent === 'string'
      ? { xs: props.alignContent }
      : props.alignContent;

  if (alignContent?.xs) {
    classNames.push(styles[`align-content-${alignContent.xs}`]);
  }
  if (alignContent?.sm) {
    classNames.push(styles[`align-content-sm-${alignContent.sm}`]);
  }
  if (alignContent?.md) {
    classNames.push(styles[`align-content-md-${alignContent.md}`]);
  }
  if (alignContent?.lg) {
    classNames.push(styles[`align-content-lg-${alignContent.lg}`]);
  }
  if (alignContent?.xl) {
    classNames.push(styles[`align-content-xl-${alignContent.xl}`]);
  }

  const wrap = typeof props.wrap === 'string' ? { xs: props.wrap } : props.wrap;

  if (wrap?.xs) {
    classNames.push(styles[`wrap-${wrap.xs}`]);
  }
  if (wrap?.sm) {
    classNames.push(styles[`wrap-sm-${wrap.sm}`]);
  }
  if (wrap?.md) {
    classNames.push(styles[`wrap-md-${wrap.md}`]);
  }
  if (wrap?.lg) {
    classNames.push(styles[`wrap-lg-${wrap.lg}`]);
  }
  if (wrap?.xl) {
    classNames.push(styles[`wrap-xl-${wrap.xl}`]);
  }

  if (props.gap) {
    const gapStyles = getSpacingStyles('gap', {
      spacing: props.gap,
    });
    classNames.push(...gapStyles);
  }
  if (props.rowGap) {
    const rowGapStyles = getSpacingStyles('row-gap', {
      spacing: props.rowGap,
    });
    classNames.push(...rowGapStyles);
  }
  if (props.columnGap) {
    const columnGapStyles = getSpacingStyles('column-gap', {
      spacing: props.columnGap,
    });
    classNames.push(...columnGapStyles);
  }
  return classNames;
}
